import { Component } from '@angular/core';
import { SessionContextService } from '../../services/session-context.service';
import { IClient, IProject } from '../../common/models/home-user.interface';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { IUserLocalStorage } from '../../common/models/auth.interface';
import { ProjectService } from '../../services/project.service';
import { IProjectData, ProjectsResponse } from '../../common/models/project.interface';
import { Role } from '../../common/enums/role.enum';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  currentClient:string | null = null;
  private subs = new Subscription();
  Role = Role;
  projects: IProjectData[] = [];
  selected: IProjectData | null = null;
  hideMenuForUrl: boolean = false;
  hideProjectDataForUrl: boolean = false;

  userData: any;
  clientsFromUserScreen: IClient | null = null;
  currentProject: any;


  constructor(
    private sessionContextService: SessionContextService,
    private authService: AuthService,
    private projectService: ProjectService
  ) {}

  ngOnInit() {
    this.userData = this.authService.getUser() as IUserLocalStorage;

    this.subs.add(
      this.authService.userData$.subscribe((user) => {
        this.userData = user;
        if (this.isAuthenticated()) {
          this.getProjects(user?.clientId as string);
        }
      }),
    );

    this.subs.add(
      this.sessionContextService
        .getClientSessionObservable()
        .subscribe((client) => {
          this.clientsFromUserScreen = client;
        }),
    );

    this.subs.add(
      this.projectService
        .getProjectFromHeaderObservable()
        .subscribe((project) => {
          console.log('proje', project)
          if (project) {
            this.currentProject = ` - ${project.name}`;
          }
        }),
    );
  }

    getProjects(clientId: string): void {
      this.projectService.getProjectsByClientId(clientId).subscribe({
        next: (res: ProjectsResponse) => {
          this.projects = res.data;

          const storedProjectId =
            this.projectService.getProjectFromLocalStorage()?.id;

          const matchingProject = this.projects.find(
            (p) => p.id === storedProjectId,
          );

          if (matchingProject) {
            this.selected = matchingProject;
          } else {
            this.selected = this.projects[0];
            this.projectService.setCurrentProject(this.selected);
          }
        },
        error: (err) => {
          console.error('Error fetching projects:', err);
        },
      });
    }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
}
